import { render, staticRenderFns } from "./style1.vue?vue&type=template&id=897f096a&scoped=true&"
import script from "./style1.vue?vue&type=script&lang=js&"
export * from "./style1.vue?vue&type=script&lang=js&"
import style0 from "./style1.vue?vue&type=style&index=0&id=897f096a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f096a",
  null
  
)

export default component.exports